<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $t("documentvarification") }}
      </div>
      <div>
        <button
          v-if="$can('update', 'Document Verification')"
          class="btn-blue"
          @click.prevent.stop="onEditDocument(documentDetails.vd_id)"
        >
          {{ $t("edit") }}
        </button>
        <router-link class="btn-blue" to="document-verification"
          >{{ $t("documentvarification") }} {{ $tc("list", 1) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">
            {{ $t("document") }} {{ $tc("name") }}
          </div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="documentDetails.vd_document_name" class="mr-3">{{
              documentDetails.vd_document_name
            }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("toverify") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="documentDetails.vd_document_verifies" class="mr-3">{{
              documentDetails.vd_document_verifies
            }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">
            {{ $tc("offer") }} {{ $tc("active") }}
          </div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="documentDetails.vd_is_active == 'Y'" class="mr-3">{{
              $t("yes")
            }}</span>
            <span v-else class="mr-3">{{ $t("no") }}</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>

      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("createdat") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="documentDetails.created_at" class="mr-3">{{
              documentDetails.created_at | dateparse
            }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("createdby") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="documentDetails.created_by" class="mr-3">{{
              documentDetails.created_by
            }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("updatedat") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="documentDetails.updated_at" class="mr-3">{{
              documentDetails.updated_at | dateparse
            }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
      <div v-if="roleID == 1" class="col-md-12 py-1">
        <div class="row">
          <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("updatedby") }}</div>
          <div class="col-md-9 col-lg-10 col-xl-10">
            <span v-if="documentDetails.updated_by" class="mr-3">{{
              documentDetails.updated_by
            }}</span>
            <span v-else class="mr-3">-</span>
            <!-- <span>12:05 AM</span> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import moment from "moment";

export default {
  data() {
    return {
      roleID: "",
      vd_id: "",

      documentDetails: [],
    };
  },

  beforeMount() {
    this.roleID = this.secureStore.get("USINFO").role_id;
    const { vd_id } = this.$route.query;

    if (vd_id) {
      this.getDocumentDetails(vd_id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    getDocumentDetails: function (vd_id) {
      MasterService.getVerificationDocumentDetails({ vd_id }).then(
        (response) => {
          const { data } = response;
          if (data.Records) {
            this.documentDetails = {
              ...this.documentDetails,
              ...data.Records[0],
            };
          }
        }
      );
    },
    onEditDocument: function (vd_id) {
      this.$router.push({
        path: "/master/edit-document-verification",
        query: { vd_id: vd_id },
      });
      // console.log("bank_id :", bank.bank_id);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/DocumentVerification/viewDocumentVerification.vue